import { render, staticRenderFns } from "./HrFeedEditPageDynamic.vue?vue&type=template&id=bbbdc798"
import script from "./HrFeedEditPageDynamic.vue?vue&type=script&lang=js"
export * from "./HrFeedEditPageDynamic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports